import classnames from "classnames";
import { debounce } from "lodash";
import { Component } from "react";
import styles from "./inputTermsAndConditions.module.css";
import { _t } from "src/redux/store";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import { connect } from "react-redux";
import { INITIAL_STATE } from "src/redux/reducers/initial-state";
import renderHTML, { domToReact } from "html-react-parser";
import * as  element from 'domhandler/lib/node';

let TERMS_LINK = "/terms-and-conditions";
let PRIVACY_LINK = "/privacy-policy";

type OwnProps = {
  classname?: string;
  name: string;
  value: boolean;
  handleOnChange: Function;
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

type State = {
  value: boolean;
  isModalOpen: boolean;
  input: {
    isValid: boolean;
    warning: string;
  };
};

class InputTermsAndConditions extends Component<Props, State> {
  linkToShow: string = '';
  termsAndConditions: string = 'TermsAndConditions';
  privacyPolicy: string = 'PrivacyPolicy'
  constructor(props: Props) {
    super(props);
    this.state = {
      value: props.value,
      isModalOpen: false,
      input: {
        isValid: true,
        warning: ""
      }
    }
    let domainList: string[];
    let domain: string;
    // if (process.env.NODE_ENV === "development") {
    //   TERMS_LINK = 'https://payments.bettingbeast.com/pt/terms-and-conditions';
    //   PRIVACY_LINK = 'https://payments.bettingbeast.com/pt/privacy-policy';
    // } else {
      try {
        domainList = window.location.origin.split(".");
        const lastTwo = domainList.slice(-2);
        domain = lastTwo.join('.');
        const langPath = this.chooseLangPath(this.props.lang);
        TERMS_LINK = 'https://payments.' + domain + langPath + TERMS_LINK;
        PRIVACY_LINK = 'https://payments.' + domain + langPath + PRIVACY_LINK;
      } catch (e) {

      }
    // }
    // const a = this.props;
    // debugger;
  }

  chooseLangPath(currentLang: string) {
    let langPath: string;
    switch (currentLang) {
      case 'pt':
        return langPath = '/pt';
      case 'es':
        return langPath = '/es';
      case 'en':
        return langPath = '/en';
      default:
        return langPath = '/en';
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.value !== this.state.value) {
      this.debouncedHandleOnChange();
    }
  }

  debouncedHandleOnChange = debounce(() => {
    this.validateInput(this.state.value);
    this.props.handleOnChange(this.props.name, this.state.value);
  }, 200);

  validateInput = (inputValue: boolean) => {
    this.setState({
      value: (inputValue),
      input: {
        isValid: inputValue,
        warning: (inputValue ? '' : _t.translate("You need to confirm Terms and Conditions and Privacy Policy"))
      },
    });
  };

  handleOnChange = (newValue: boolean,) => {
    this.setState({ value: newValue });
  };

  handleClickOpenModal = (e: any) => {
    this.setState({ isModalOpen: true });
    if (e.target.id === 'TermsAndConditions') {
      this.linkToShow = TERMS_LINK;
    } else {
      this.linkToShow = PRIVACY_LINK;
    }
  };

  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
  }


  render() {
    return (
      <div
        className={classnames(
          styles.formControl,
          typeof this.props.classname !== "undefined" && this.props.classname
        )}
      >
        <span className={styles.label}>{_t.translate("Terms And Conditions")}</span>
        <div className={styles.inputContainer}>
          <Checkbox
            onChange={(e) => this.handleOnChange(e.target.checked)}
            checked={this.state.value}
            className={styles.checkbox} />
          <label className={styles.inputWrapper}> {renderHTML(
            _t.translate(
              "I confirm I have read and I agree to the <a id='{{TermsAndConditions}}' href='#'>Terms and Conditions</a> and <a id='{{PrivacyPolicy}}' href='#'>Privacy Policy</a> and confirm I am 18 years of age or over.",
              { TermsAndConditions: this.termsAndConditions, PrivacyPolicy: this.privacyPolicy },
            ),
            {
              replace: domNode => {
                if (domNode instanceof element.Element) {
                  return (
                    <a {...domNode.attribs}
                      onClick={this.handleClickOpenModal}>{domToReact(domNode.children)}</a>
                  );
                }

              }
            }

          )}
          </label>
        </div>
        <Dialog
          fullWidth
          open={this.state.isModalOpen}
          onClose={this.handleCloseModal}>
          <div className={styles.dialog}>
            <iframe src={this.linkToShow} frameBorder="0" width="100%" height="100%" title="termsAndConditions"></iframe>
          </div>
        </Dialog>
      </div>
    )
  }
}

const mapStateToProps = (state: typeof INITIAL_STATE) => {
  return {
    lang: state.settings.userLang,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {};
};


export default connect(mapStateToProps, mapDispatchToProps)(InputTermsAndConditions);